<template>
  <div class="fccRelatorios">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage :titlePage="titlePage"></fccTitlePage>
      <fccTable
        striped
        hover
        :fields="fieldsRelatorio"
        responsive
        :porPage="itemPorPage"
        search
        pagination
        fieldVisibility
        pdf
        csv
        xls
        :titlePage="titlePage"
        :titlePDF="titlePDF"
        :items="listaRelatorio"
        :actions="actionsRelatorio"
      />
      <fccModal
        centered
        idModal="viewRelatorio"
        size="xl"
        :titleModal="titleModal"
        escondeFooter
        travaEsc
        travaBack
      >
        <div class="row">
          <div class="col-sm-6 titlePage">Quantidade de registros: {{ contador }}</div>

          <div class="col-sm-6 text-right">
            <download-csv
              :data="listarCache"
              class="btn btn-light border shadow-sm ml-2 text-dark"
              :name="nameJson"
              v-b-tooltip.hover
              title="Gerar CSV"
            >
              <font-awesome-icon icon="file-csv" size="lg" />
            </download-csv>

            <a v-b-tooltip.hover title="Gerar XLS">
              <export-excel
                :data="listarCache"
                :name="nameExcel"
                class="btn btn-light border shadow-sm ml-2 text-success"
              >
                <font-awesome-icon icon="file-excel" size="lg" />
              </export-excel>
            </a>
          </div>
        </div>

        <div class="mt-2" v-if="parametros">
          Parâmetros utilizados: <span class="text-primary"> {{ parametros }}</span>
        </div>

        <div class="row">
          <div v-for="item in fieldsCache" :key="item.key" class="col-sm-4 mt-2">
            <toggle-button v-model="item.active" @change="alteraFields(item)" />
            {{ item.key }}
          </div>
        </div>
      </fccModal>
      <div class="row"></div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'
import './assets/sass/fccRelatorios.scss'

export default {
  data() {
    return {
      sortBy: 'ordem',
      titlePage: 'Relatórios',
      titlePDF: 'Lista de Relatórios',
      listarView: [],
      listaRelatorio: [],
      listarCache: [],
      nameJson: 'JsonFcc-' + this.geraNome() + '.csv',
      nameExcel: 'ExcelFcc-' + this.geraNome() + '.xls',
      fieldsCache: [],
      fields: [],
      parametros: '',
      titleModal: '',
      contador: 0,
      itemPorPage: '100',
      listagemCondicao: [
        {
          nome: 'ordenado por',
          valor: 'ORDER BY'
        },
        {
          nome: ' descendente ',
          valor: ' DESC '
        },
        {
          nome: ' ascendente ',
          valor: ' ASC '
        },
        { nome: ' e ', valor: ' AND ' },
        { nome: ' ou ', valor: ' OR ' },
        {
          nome: 'igual',
          valor: '='
        },
        {
          nome: 'diferente de',
          valor: '<>'
        },
        {
          nome: 'não contém',
          valor: 'NOT LIKE'
        },
        {
          nome: "começa com '$1'",
          valor: new RegExp("LIKE '([^'%]*)%'", 'g')
        },
        {
          nome: "termina com '$1'",
          valor: new RegExp("LIKE '%([^'%]*)'", 'g')
        },
        {
          nome: "contém '$1'",
          valor: new RegExp("LIKE '%([^'%]*)%'", 'g')
        },
        {
          nome: 'maior que',
          valor: '>'
        },
        {
          nome: 'maior ou igual',
          valor: '>='
        },
        {
          nome: 'menor que',
          valor: '<'
        },
        {
          nome: 'menor ou igual',
          valor: '<='
        }
      ],
      actionsRelatorio: [
        {
          button: true,
          funcaoButton: 'listandoRelatorioToken',
          icon: 'eye',
          tooltip: 'Visualizar',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      fieldsRelatorio: [
        { key: 'filproid', label: 'ID', sortable: true, active: true },
        { key: 'filprodescricao', label: 'Relatório', sortable: true, active: true },
        { key: 'filproemailaviso', label: 'E-mail', sortable: true, active: true },
        {
          key: 'filproinicio',
          label: 'Data solicitação',
          sortable: true,
          active: true,
          type: 'datahora'
        },
        {
          key: 'filprofim',
          label: 'Data resposta',
          sortable: true,
          active: true,
          type: 'datahora'
        },
        { key: 'actions', label: '' }
      ]
    }
  },
  methods: {
    listarRelatorioUser: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlRelatorios +
            'Relatorio/ListaRelatoriosFilaPorUsuario?usuID=' +
            this.dadosUserSession.usuID,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listaRelatorio = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listandoRelatorioToken: function (_, item) {
      this.parametros = ''
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlRelatorios + 'Relatorio/ListaRelatoriosFilaPorId/' + item.filproid,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          let parametros = response.data.Parametros
          if (parametros) {
            this.listagemCondicao.forEach((element) => {
              parametros = parametros.replaceAll(element.valor, element.nome)
            })
          }
          this.parametros = parametros
          this.titleModal = 'Relatório ' + item.filprodescricao
          this.listarView = response.data.D1.Relatorio
          this.contador = this.listarView.length
          this.listarCache = JSON.parse(JSON.stringify(this.listarView))
          this.gerandoFields()
          this.$root.$emit('bv::show::modal', 'viewRelatorio')
          this.carregaTexto()
        })
        .catch((error) => {
          this.setErrorSystem(error)
        })
    },
    gerandoFields: function () {
      this.fields = []
      for (var [key] of Object.entries(this.listarView[0])) {
        this.fields.push({
          key: key,
          label: key,
          sortable: true,
          active: true
        })
      }
      this.fieldsCache = []
      this.fieldsCache = JSON.parse(JSON.stringify(this.fields))
    },
    alteraFields: function (item) {
      this.carregaTexto(this.codeMensagem('C01'))
      if (item.active === false) {
        this.listarCache.forEach((element) => {
          delete element[item.key]
        })
      } else {
        this.listarView.forEach((element, index) => {
          this.listarCache[index][item.key] = element[item.key]
        })
      }
      this.carregaTexto()
    }
  },
  created: function () {
    this.fechandoNotificacoes()
  },
  mounted: function () {
    this.baseUrlRelatorios = store.state.baseUrlRelatorios
    this.tokenRelatorio = this.$route.query.token === undefined ? false : this.$route.query.token
    this.listarRelatorioUser()
  },
  watch: {
    $route() {
      this.fechandoNotificacoes()
    }
  }
}
</script>
